module.exports = __webpack_public_path__ + "img/filorga_box_noel.cc0336da.jpg";